const state = {
    landings: [],
    languages: [],
    teamsList: []
}

export default state
